var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1876 13.9375L33.8594 20.6093M6.57819 34.5625C5.86706 35.3789 5.47534 36.4251 5.47534 37.5078C5.47534 38.5905 5.86706 39.6367 6.57819 40.4531L34.5626 68.4375C35.379 69.1486 36.4252 69.5403 37.5079 69.5403C38.5906 69.5403 39.6367 69.1486 40.4532 68.4375L68.4219 40.4531C69.1393 39.6396 69.5351 38.5923 69.5351 37.5078C69.5351 36.4232 69.1393 35.3759 68.4219 34.5625L40.4532 6.5781C39.6486 5.84316 38.5892 5.4508 37.5001 5.48435C36.4135 5.45581 35.359 5.85405 34.5626 6.59372L6.57819 34.5625ZM41.1407 27.8906L47.1094 33.8593L41.1407 27.8906Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 55.7969C40.3477 55.7969 42.6562 53.4883 42.6562 50.6406C42.6562 47.7929 40.3477 45.4844 37.5 45.4844C34.6523 45.4844 32.3438 47.7929 32.3438 50.6406C32.3438 53.4883 34.6523 55.7969 37.5 55.7969Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.4062C40.3477 29.4062 42.6562 27.0977 42.6562 24.25C42.6562 21.4023 40.3477 19.0938 37.5 19.0938C34.6523 19.0938 32.3438 21.4023 32.3438 24.25C32.3438 27.0977 34.6523 29.4062 37.5 29.4062Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 42.6562C53.5977 42.6562 55.9062 40.3477 55.9062 37.5C55.9062 34.6523 53.5977 32.3438 50.75 32.3438C47.9023 32.3438 45.5938 34.6523 45.5938 37.5C45.5938 40.3477 47.9023 42.6562 50.75 42.6562Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45.4844V29.4062",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.0f720d15e636ce5107a4df620b8c448f.svg";
export { ForwardRef as ReactComponent };